import type { ResultEntry } from '@schibsted-nmp/search-frontend-clients/quest';
import { BapSearchAd } from '@schibsted-nmp/search-frontend-components/react';
import React from 'react';
import { useAdTracking } from '../../tracking/useAdTracking';
import { FavoriteHeart } from './FavoriteHeart';
import { useLayout } from './layout/LayoutStore';
import { useSearchItems } from './useSearchItems';

type ResultItemProps = {
    ad: ResultEntry;
    imageSizes: string;
    position: number;
};

export function ResultItem(props: ResultItemProps) {
    const { ad, imageSizes, position } = props;

    const { layout } = useLayout();
    const { storeSearchItems } = useSearchItems();
    const { trackAdClick, trackAdInscreen } = useAdTracking();

    const handleAdClick = React.useCallback(() => {
        trackAdClick(ad, position);
        storeSearchItems(ad);
    }, [ad, position, storeSearchItems, trackAdClick]);

    const handleAdInscreen = React.useCallback(() => {
        trackAdInscreen(ad, position);
    }, [ad, position, trackAdInscreen]);

    const adProps = {
        id: ad.id,
        imageSizes,
        layout,
        onClick: handleAdClick,
        onFirstInscreen: handleAdInscreen,
        url: ad.canonical_url,
    };

    if (ad.type === 'bap') {
        return (
            <BapSearchAd
                ad={ad}
                favorite={() => (
                    <FavoriteHeart
                        itemId={ad.id}
                        variant={layout === 'grid' ? 'heart-on-image' : 'heart'}
                    />
                )}
                {...adProps}
            />
        );
    }

    return null;
}
